import { render } from "./UnderwaterTransition.vue?vue&type=template&id=6cac4b7c&scoped=true"
import script from "./UnderwaterTransition.vue?vue&type=script&lang=js"
export * from "./UnderwaterTransition.vue?vue&type=script&lang=js"

import "./UnderwaterTransition.vue?vue&type=style&index=0&id=6cac4b7c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cac4b7c"]])

export default __exports__